import { createContext, useContext } from 'react';
import type { HilfeUebersicht } from './hilfeApi';

// Zustand der Seite für ihre Unterseiten (PF-308-1). Eigene Datei, damit Unterseiten nicht HilfeSeite.tsx importieren.
export type HilfeZustand = {
  /** null, solange die Übersicht lädt oder nicht geladen werden konnte. */
  uebersicht: HilfeUebersicht | null;
  laden: boolean;
  fehler: boolean;
  /** Neuer Versuch, die Übersicht zu laden. */
  nochmals: () => void;
  /** Sicht des Betreibers: alles nur lesend. */
  sicht: boolean;
};

export const HilfeKontext = createContext<HilfeZustand>({ uebersicht: null, laden: false, fehler: false, nochmals: () => undefined, sicht: false });
export const useHilfe = () => useContext(HilfeKontext);
